module.exports = __webpack_public_path__ + "a9e05524f8c8240feea588b9892ce3e7.png";